import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  FormControl,
  FormLabel,
  HStack,
  Text,
  Tooltip,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { IconButton } from '@chakra-ui/button';
import Icon from '@chakra-ui/icon';
import { FaRegTimesCircle } from 'react-icons/fa';
import { Button, ColorfulBar, Input, Select } from '~/components';
import { isUUID } from '~/utils/uuid';

export interface BeforeDueDateProps {
  id: string;
  valor: number;
  onChange: (id: string, value: any) => void;
  excluir?: (id: string) => void;
  podeExcluir: boolean;
}
export const BeforeDueDate: React.VFC<BeforeDueDateProps> = ({
  id,
  valor,
  onChange,
  excluir,
  podeExcluir,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { setError, formState, clearErrors } = useForm();
  const { errors } = formState;
  const [inputValue, setInputValue] = useState(valor);
  const changeInputValue = (e: string) => {
    const numberValue = Number(e);
    if (Number.isNaN(numberValue)) {
      return;
    }
    setInputValue(numberValue);
    if (numberValue === 0 || numberValue > 30) {
      setError('qtd_dias', {
        type: 'manual',
        message: 'Informe um valor entre 1 e 30',
      });
      return;
    }
    clearErrors('qtd_dias');
  };

  const isValid = inputValue > 0 && inputValue <= 30;

  return (
    <HStack fontSize="14px" gridGap={2}>
      <FormControl isRequired isInvalid={!!errors} w="160px">
        <FormLabel mb={1} fontSize="14px" whiteSpace="nowrap">
          Enviar e-mail
        </FormLabel>
        <Input
          w="160px"
          name="qtd_dias"
          type="text"
          error={errors?.qtd_dias}
          value={inputValue}
          onChange={e => {
            changeInputValue(e.target.value);
          }}
          onBlur={() => {
            if (isValid && (inputValue !== valor || isUUID(id))) {
              onChange(id, inputValue);
            }
          }}
        />
      </FormControl>
      <HStack
        paddingTop={!formState.isValid ? '' : '27px'}
        paddingBottom={!formState.isValid ? '22px' : ''}
      >
        <Text alignItems="center" display="flex" fontSize="16px">
          dia(s) antes
        </Text>
        {podeExcluir && (
          <Tooltip label="Excluir">
            <IconButton
              colorScheme="gray"
              background="transparent"
              _hover={{
                background: 'transparent',
              }}
              aria-label="delete"
              icon={<Icon as={FaRegTimesCircle} w={6} h={6} />}
              onClick={() => {
                !!valor && onOpen();
                !valor && excluir && excluir(id);
              }}
            />
          </Tooltip>
        )}
      </HStack>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={undefined}
        onClose={onClose}
        isOpen={isOpen}
        isCentered
        closeOnOverlayClick={false}
        size="xl"
      >
        <AlertDialogOverlay />

        <AlertDialogContent width={800}>
          <ColorfulBar />
          <AlertDialogHeader>Atenção</AlertDialogHeader>
          <AlertDialogBody>Deseja excluir esta configuração?</AlertDialogBody>
          <AlertDialogFooter>
            <Button
              onClick={() => {
                onClose();
              }}
              variant="secondary"
              width={100}
            >
              Cancelar
            </Button>
            <Button
              onClick={() => {
                excluir && excluir(id);
                onClose();
              }}
              variant="primary"
              width={100}
              ml={3}
            >
              OK
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </HStack>
  );
};
